import type { RequestUnderlyingsDatesEpicApi } from 'epic/common-form/requestUnderlyingsDatesEpics';
import { map } from 'rxjs/operators';
import type {
  UnderlyingsDatesBlackoutDatesResponse,
  UnderlyingsDatesSpecificDatesResponse,
} from 'state/underlyingsDates/underlyingsDatesState.model';
import type { IHttpClient } from 'utils/http/httpClient.model';

export function underlyingsDatesApiConnector(httpClient: IHttpClient): RequestUnderlyingsDatesEpicApi {
  return {
    requestUnderlyingsDatesEpicApisBlackoutDates(underlyingsDates) {
      return httpClient
        .postJSON<UnderlyingsDatesBlackoutDatesResponse>({
          url: 'dlp/api/v1/underlying/dates/blackoutperiods',
          body: underlyingsDates,
        })
        .pipe(map(({ payload }) => payload));
    },
    requestUnderlyingsDatesEpicApisSpecificDates(underlyingsDates) {
      return httpClient
        .postJSON<UnderlyingsDatesSpecificDatesResponse>({
          url: 'dlp/api/v1/underlying/dates/specificdates',
          body: underlyingsDates,
        })
        .pipe(map(({ payload }) => payload));
    },
  };
}
